import "aos/dist/aos.css";
import React from 'react';
import { LuArrowRight, LuCalendarDays, LuMapPin } from "react-icons/lu";
import { Link } from "react-router-dom";
import "./meeting.scss";

const AnnualMeetingArchive = ({ data, items, language }) => {
  const getLocalizedField = (item, field) => {
    if (!item) return "";

    if (language) {
      const englishValue = item[`${field}_en`];
      if (typeof englishValue === "string" && englishValue.trim()) return englishValue;
    }

    const value = item[field];
    return typeof value === "string" ? value : value || "";
  };

  return (
    <section className="meetings-archive">
      {items.length > 0 ?
        items.map((item) => {
          const title = getLocalizedField(item, "title");
          const description = getLocalizedField(item, "description");
          const location = getLocalizedField(item, "location");
          const detailPath = "/annual-meeting/" + item.id;
          const formattedDate = item.dt
            ? new Date(item.dt).toLocaleString(language ? "en-US" : "mn-MN", {
              year: 'numeric',
              month: 'long',
              day: 'numeric',
              hour: '2-digit',
              minute: '2-digit'
            })
            : "";

          return (
            <article key={"event-" + item.id} className='event-item'>
              <Link className="event-img" to={detailPath} aria-label={title} target="_blank" rel="noopener noreferrer">
                <img
                  src={`https://msid-asset.s3.ap-northeast-2.amazonaws.com/${item.fileUrl}`}
                  alt={title}
                />
              </Link>
              <div className='event-info'>
                <Link className="event-name" to={detailPath}>
                  {title}
                </Link>
                {description ? (
                  <div className="event-desc max-line-2">
                    {description}
                  </div>
                ) : null}
                <div className="event-meta">
                  {location ? (
                    <div className="event-location">
                      <LuMapPin aria-hidden="true" />
                      <span>{location}</span>
                    </div>
                  ) : null}
                  {formattedDate ? (
                    <div className="event-time">
                      <LuCalendarDays aria-hidden="true" />
                      <span>{formattedDate}</span>
                    </div>
                  ) : null}
                </div>
                <Link className="archive-card-link" to={detailPath} target="_blank" rel="noopener noreferrer">
                  <span>{language ? "View details" : "Дэлгэрэнгүй"}</span>
                  <LuArrowRight aria-hidden="true" />
                </Link>
              </div>
            </article>
          );
        })
        :
        <div className='archive-empty-state'>
          {data.noDataFound}
        </div>
      }
    </section>
  );
};
export default AnnualMeetingArchive;
